// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    background: #f7f7f7;
    padding: 0px 0px 0px 0px;
    font-family: "Noto Sans", sans-serif;
}

.top-bar {
    display: flex;
    align-items: center;
    gap: 20px;
    background: #eee;
    padding: 0px;
    z-index: 9999;
}

.title-box h3 {
    color: #ff6b00;
    margin: 0;
    font-size: 12px;
}

.title-box p {
    font-size: 12px;
    color: #777;
    margin: 0;
}

.stats-scroll {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: thin;
}

.stats {
    display: flex;
    flex-wrap: nowrap;
    min-width: max-content;
    gap: 0px;
    margin-left: auto;
    justify-content: flex-end;
}

.stat {
    background: #fff;
    text-align: left;
    border-right: 1px solid #D2D2D6;
    border-left: 1px solid #D2D2D6;
    width: 80px;
    padding: 0px 0px 0px 5px;
}

.stat span {
    font-size: 11px;
    color: #141414;
    line-height: 0px;
}

.stat h2,
.stat h3 {
    margin: 0px 0 0;
    color: #000;
    font-size: 13px;
    font-weight: bold;
}

.truck {
    background: #CCFBF1;
}

.bus,
.Bus {
    background: #F5D0FE;
}

.car,
.Car {
    background: #a8bfe4;
}

.motorcycle {
    background: #F3E8FF;
}

.bike,
.Bicycle {
    background: #c895f8;
}

.person{
    background: #97f0cf;
}

.Pedestrian {
    background: #b6e8c8;
}

.HGV {
    background: #80b4f5;
}

.LCV {
    background: #FEF9C3;
}

.auto {
    background: #FFEDD5;
}

.pet {
    background: #DBEAFE;
}

.ttc {
    background: #FFEDD5;
}

.chart-box {
    background: #fff;
}

.date {
    text-align: center;
    margin-top: 0px;
    color: #000;
    font-weight: bold;
    font-size: 10px;
    margin-bottom: -10px;
}

.content-div {
    background-color: #fff;
    width: 100%;
    overflow-y: auto;
}

.chart-canvas-wrap {
  position: relative;
  width: 100%;
  height: clamp(110px, 23vh, 320px);
  padding: 0;
}

@media (max-width: 1024px) {
  .chart-canvas-wrap {
    height: clamp(120px, 26vh, 200px);
  }
}

@media (max-width: 640px) {
  .chart-canvas-wrap {
    height: clamp(140px, 32vh, 220px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/vehicle.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;IAC/B,8BAA8B;IAC9B,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF","sourcesContent":[".container {\n    background: #f7f7f7;\n    padding: 0px 0px 0px 0px;\n    font-family: \"Noto Sans\", sans-serif;\n}\n\n.top-bar {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    background: #eee;\n    padding: 0px;\n    z-index: 9999;\n}\n\n.title-box h3 {\n    color: #ff6b00;\n    margin: 0;\n    font-size: 12px;\n}\n\n.title-box p {\n    font-size: 12px;\n    color: #777;\n    margin: 0;\n}\n\n.stats-scroll {\n    width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scrollbar-width: thin;\n}\n\n.stats {\n    display: flex;\n    flex-wrap: nowrap;\n    min-width: max-content;\n    gap: 0px;\n    margin-left: auto;\n    justify-content: flex-end;\n}\n\n.stat {\n    background: #fff;\n    text-align: left;\n    border-right: 1px solid #D2D2D6;\n    border-left: 1px solid #D2D2D6;\n    width: 80px;\n    padding: 0px 0px 0px 5px;\n}\n\n.stat span {\n    font-size: 11px;\n    color: #141414;\n    line-height: 0px;\n}\n\n.stat h2,\n.stat h3 {\n    margin: 0px 0 0;\n    color: #000;\n    font-size: 13px;\n    font-weight: bold;\n}\n\n.truck {\n    background: #CCFBF1;\n}\n\n.bus,\n.Bus {\n    background: #F5D0FE;\n}\n\n.car,\n.Car {\n    background: #a8bfe4;\n}\n\n.motorcycle {\n    background: #F3E8FF;\n}\n\n.bike,\n.Bicycle {\n    background: #c895f8;\n}\n\n.person{\n    background: #97f0cf;\n}\n\n.Pedestrian {\n    background: #b6e8c8;\n}\n\n.HGV {\n    background: #80b4f5;\n}\n\n.LCV {\n    background: #FEF9C3;\n}\n\n.auto {\n    background: #FFEDD5;\n}\n\n.pet {\n    background: #DBEAFE;\n}\n\n.ttc {\n    background: #FFEDD5;\n}\n\n.chart-box {\n    background: #fff;\n}\n\n.date {\n    text-align: center;\n    margin-top: 0px;\n    color: #000;\n    font-weight: bold;\n    font-size: 10px;\n    margin-bottom: -10px;\n}\n\n.content-div {\n    background-color: #fff;\n    width: 100%;\n    overflow-y: auto;\n}\n\n.chart-canvas-wrap {\n  position: relative;\n  width: 100%;\n  height: clamp(110px, 23vh, 320px);\n  padding: 0;\n}\n\n@media (max-width: 1024px) {\n  .chart-canvas-wrap {\n    height: clamp(120px, 26vh, 200px);\n  }\n}\n\n@media (max-width: 640px) {\n  .chart-canvas-wrap {\n    height: clamp(140px, 32vh, 220px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
